import { ref } from 'vue';

const defaultOptions = {
  immediate: true,
  initialData: null,
  errorHandler: (err, siteUrl) => {
    console.error(err);
  },
};

const useApiCall = (apiCall, mapper, options, showSnackbar = true) => {
  const mergedOptions = { ...defaultOptions, ...options };

  const loading = ref(false);
  const error = ref(false);
  const data = ref(mergedOptions.initialData);

  const reset = () => {
    loading.value = false;
    error.value = false;
    data.value = mergedOptions.initialData;
  };

  const callApi = async (...params) => {
    const siteUrl = document.location.href;
    try {
      error.value = false;
      loading.value = true;
      const res = await apiCall(...params);
      if (mapper) {
        data.value = mapper(res);
      } else {
        data.value = res;
      }
      return res;
    } catch (err) {
      error.value = err;
      if (showSnackbar) {
        mergedOptions.errorHandler(err, siteUrl, defaultOptions.errorHandler);
      }
      return null;
    } finally {
      loading.value = false;
    }
  };
  if (mergedOptions.immediate) {
    callApi();
  }
  return {
    loading, error, data, callApi, reset,
  };
};

export default useApiCall;
